<template>
  <div class="unsubscribe-link ph-no-capture ph-mask" data-private>
    <SrpButton tag="button" type="button" size="small" color="gray" fill="outlined" :disabled="isLoading" :isDisabled="isLoading" @click="loadLink">Unsubscribe link</SrpButton>
    <span v-if="isLoading" role="status"> Loading...</span>
    <p v-if="error" role="alert">{{ error }}</p>
    <div v-if="link" class="unsubscribe-link__result">
      <label for="opportunity-unsubscribe-link">Creator visit opportunity unsubscribe link</label>
      <textarea id="opportunity-unsubscribe-link" :value="link" readonly rows="3" class="global-text-input ph-no-capture ph-mask" />
      <SrpButton tag="button" type="button" size="tiny" fill="outlined" @click="copyLink">{{ copied ? "Copied" : "Copy link" }}</SrpButton>
      <p>Expires {{ new Date(expiresAt).toLocaleDateString() }}. Opening this link asks for confirmation before unsubscribing.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import axios from "axios";
import SrpButton from "@components/ui/SrpButton.vue";

const props = defineProps<{ creatorId: string }>();
const link = ref("");
const expiresAt = ref("");
const isLoading = ref(false);
const copied = ref(false);
const error = ref("");
let requestVersion = 0;

watch(() => props.creatorId, () => {
  requestVersion++;
  link.value = expiresAt.value = error.value = "";
  isLoading.value = copied.value = false;
}, { flush: "sync" });

async function loadLink() {
  const version = ++requestVersion;
  isLoading.value = true;
  error.value = link.value = "";
  copied.value = false;
  try {
    const response = await axios.get(import.meta.env.VITE_API_URL + "/profile/" + encodeURIComponent(props.creatorId) + "/opportunity-unsubscribe-link");
    if (version !== requestVersion) return;
    link.value = response.data.url;
    expiresAt.value = response.data.expiresAt;
  } catch {
    if (version === requestVersion) error.value = "Couldn't load the unsubscribe link. Try again; the email signing configuration may not be ready yet.";
  } finally {
    if (version === requestVersion) isLoading.value = false;
  }
}

async function copyLink() {
  try {
    await navigator.clipboard.writeText(link.value);
    copied.value = true;
  } catch {
    error.value = "Select and copy the link above.";
  }
}
</script>

<style scoped>
.unsubscribe-link__result { margin-top: 16px; max-width: 720px; }
.unsubscribe-link__result textarea { display: block; width: 100%; margin: 8px 0; overflow-wrap: anywhere; }
.unsubscribe-link__result p { margin-top: 10px; }
</style>
